import React, { useMemo, useState } from 'react'
import AbsenceRequestConflictsCard from 'components/AbsenceRequestConflicts/AbsenceRequestConflictsCard'
import useActivePersonsOfUser from 'hooks/useActivePersonsOfUser'
import { AbsenceRequestContext } from '../../AbsenceRequestContext'

interface INewAbsenceRequestAlertListProps {
  startDate?: string
  endDate?: string
  onClickConflict?: () => void
  showAbsencePlannerPreview?: boolean
  selectedPersonUuid?: string
}

const NewAbsenceRequestAlertList: React.FC<INewAbsenceRequestAlertListProps> = ({
  startDate,
  endDate,
  onClickConflict,
  showAbsencePlannerPreview,
  selectedPersonUuid,
}) => {
  const [showAbsencePlannerDrawer, setShowAbsencePlannerDrawer] = useState<boolean>(false)

  const validDates = startDate && endDate

  const { persons } = useActivePersonsOfUser()
  const selectedPerson = useMemo(
    () => (persons ?? []).find(({ favurUuid }) => selectedPersonUuid === favurUuid),
    [persons, selectedPersonUuid],
  )

  if (!validDates) return null

  return (
    <AbsenceRequestContext.Provider
      value={{
        showAbsencePlannerDrawer,
        setShowAbsencePlannerDrawer: setShowAbsencePlannerDrawer,
      }}
    >
      <AbsenceRequestConflictsCard
        startDate={startDate}
        endDate={endDate}
        noPadding
        onClick={onClickConflict}
        previewPerson={selectedPerson}
        showAbsencePlannerPreview={showAbsencePlannerPreview}
        setShowAbsencePlannerDrawer={setShowAbsencePlannerDrawer}
        showAbsencePlannerDrawer={showAbsencePlannerDrawer}
      />
    </AbsenceRequestContext.Provider>
  )
}

export default NewAbsenceRequestAlertList
